import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getStoresRequest} from '../../../store/actions/store';
import { withRouter } from 'react-router-dom';
import WarehouseSelectModal from './WarehouseSelectModal';
import { storesSelector } from '../../../store/selectors/store';
import { createStructuredSelector } from 'reselect';
import { filtersStoresToUseInQuerySelector } from '../../../store/selectors/filters';

const mapStateToProps = createStructuredSelector({
    store: storesSelector,
    filtersToUseInQuery: filtersStoresToUseInQuerySelector,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getStoresRequest,
        },
        dispatch
    );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WarehouseSelectModal));